











import { defineComponent, reactive } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import SearchInput from '@/components/organisms/special-offers/SearchInput.vue'
import SpecialOffersTable from '@/components/organisms/special-offers/SpecialOffersTable.vue'
import useVuex from '@/utils/useVuex'
import { SpecialOfferState, UserState } from '@/types/store'
import { UserRole } from '@/types/user'
import { GetSpecialOfferQuery } from '@/types/special-offer'

export default defineComponent({
  name: 'SpecialOffer',
  components: { Layout, SearchInput, SpecialOffersTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      specialOffers: useVuex<SpecialOfferState['specialOffers']>(
        context,
        () => store.getters['specialOffer/specialOffers'],
      ),
      isSpecialOfferLoading: useVuex<
        SpecialOfferState['isSpecialOfferLoading']
      >(context, () => store.getters['specialOffer/isSpecialOfferLoading']),
    })

    const search = (query: GetSpecialOfferQuery) => {
      store.dispatch('specialOffer/getSpecialOffers', query)
    }

    return { state, UserRole, search }
  },
})
